<template>
    <div class="navbar">
            <el-aside :width="isCollapse ? '64px' : '150px'">
                <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
                <!-- 侧边栏菜单区域 -->
                <el-menu
                    background-color="#ffffff"
                    text-color="#000000"
                    active-text-color="#409EFF"
                    :unique-opened="true"
                    :collapse="isCollapse"
                    :collapse-transition="false"
                    :router="true"
                    :default-active="this.$route.path">
                        <el-submenu :index="item.id + ''"  v-for="item in getListData" :key="item.id" :class="menus==item.name?'is-active':''">
                        <!-- 一级菜单的模版区域 -->
                        <template slot="title">
                            <!-- 图标 -->
                            <!-- <i class="el-icon-coordinate"></i> -->
                            <!-- 文本 -->
                          <i :class="item.icon"></i>
                          <span >{{ item.name }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item :index="'/' + subItem.path"  v-for="subItem in item.children" :key="subItem.id" :class="menu==subItem.name?'is-active':''" >
                                 <i :class="subItem.icon"></i>
                              <span >{{subItem.name}}</span>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
        </div>
</template>
<script>
    export default {
        data(){
            return {
                menus:'',
                menu:'',
                isCollapse: false,            // 是否折叠
                getListData:[]
            }
        },
        created() {
            this.menuData()
        },
        methods:{
            menuData() {
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token')
                }
                this.$axios.companyModuleList(param).then(res=>{
                    if(res.code == 200){
                        // //console.log(res);
                        this.getListData = res.data
                    }else{
                      this.$message.error(res.msg);
                    }
                })
            }
        },
        // 点击按钮，切换菜单的折叠与展开
        // toggleCollapse () {
        //     this.isCollapse = !this.isCollapse
        // },
        watch:{
            '$route'(to,from){
                 //console.log('to---------',to)
                 this.menu=to.meta.text;
                 this.menus=to.meta.text1;
                //console.log('menu---------', this.menu)
                //console.log('menus---------', this.menus)
            }

        }
    }

</script>

<style scoped lang="less" scope>
    .navbar{
      //padding-top: 30px;
      width: 150px;
      background-color: #ffffff;
    }
    .el-header {
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        padding-left: 0;
        align-items: center;
        color: #000;
        font-size: 20px;
    }
        .top_head_left {
            width: 500px;
            display: flex;
            align-items: center;
        }
            .top_head_left img {
            width: 50px;
            height: 50px;
        }
        .top_head_left span{
        margin-left: 15px;
        }
        .top_head_right {
        text-align: right;
        margin-right: 50px;
    }

    .margin_right {
        margin-right: 30px;
        }

    .el-header .el-button {
        background-color: transparent;
        border: none;
        color: #fff;
    }
    .el-header .el-button:hover {
        background-color: #ffffff;
    }

    .top_head_center {
        font-size: 16px;
        margin-left: 40px;
    }
    .el-submenu__title{
    text-align: left;
    }

    .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
    }
    ::v-deep.el-menu-item-group__title{
        padding: 0;
        line-height: normal;
        font-size: 12px;
        color: #909399;
    }
    /deep/.el-submenu.is-active .el-submenu__title{
        height: 45px!important;
        line-height: 45px!important;
    }
    /deep/.el-submenu .el-menu-item{
        height: 40px;
        line-height: 40px;
        padding-left: 15px!important;
    }
    .el-menu-item-group .is-active{
      background-color: #83C6FF !important;
      //color: #0383F2 !important;
      //background-color: rgb(90, 177, 239) !important;
      color: #ffffff !important;
        font-size: 14px;
    }
    /deep/.el-submenu__icon-arrow{
      right:40px
    }
    & .el-submenu .el-menu-item {
      &:hover {
        margin-left: -20px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/view/layout/Navbar.vue